import { OnInit, EventEmitter } from '@angular/core';
import { DetailProperty } from '../objects/DetailObject';
import Quill from 'quill';
// tslint:disable-next-line:variable-name no-var-requires
// import QuillImageDropAndPaste from 'quill-image-drop-and-paste'
import { ImageDrop } from 'quill-image-drop-module';
Quill.register('modules/imageDrop', ImageDrop);
// from the index, which exports a lot of useful modules
import BlotFormatter from 'quill-blot-formatter';
// // or, from each individual module
// import BlotFormatter from 'quill-blot-formatter/dist/BlotFormatter';
// Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste)
Quill.register('modules/blotFormatter', BlotFormatter);
var HtmlEditorComponent = /** @class */ (function () {
    function HtmlEditorComponent() {
        this.valueChange = new EventEmitter();
        this.modules = {
            blotFormatter: {},
            imageDrop: true
            // imageDropAndPaste: {
            //   // add an custom image handler
            //   handler: this.imageHandler
            // }
        };
    }
    HtmlEditorComponent.prototype.clickout = function (event) {
        if (document.querySelectorAll(".blot-formatter__overlay").length > 0) {
            if (this.quill.elementRef.nativeElement.contains(event.target)) {
                document.querySelectorAll(".blot-formatter__overlay").item(0).classList.remove("brn-hidden");
            }
            else {
                if (this.property) {
                    document.querySelectorAll(".blot-formatter__overlay").item(0).classList.add("brn-hidden");
                    this.onValueChange(this.property.PropertyValue);
                }
            }
        }
    };
    HtmlEditorComponent.prototype.ngOnInit = function () {
    };
    HtmlEditorComponent.prototype.onValueChange = function (value) {
        this.valueChange.emit(value);
    };
    /**
    * Do something to dropped or pasted image
    * @param.imageDataUrl - image's base64 url
    * @param.type - image's mime type
    */
    HtmlEditorComponent.prototype.imageHandler = function (imageDataUrl, type) {
        // give a default mime type if the type was null
        console.log(imageDataUrl);
        //   if (!type) type = 'image/png'
        //   // base64 to blob
        //   var blob = base64StringToBlob(base64URL.replace(/^data:image\/\w+;base64,/, ''), type)
        //   var filename = ['my', 'cool', 'image', '-', Math.floor(Math.random() * 1e12), '-', new Date().getTime(), '.', type.match(/^image\/(\w+)$/i)[1]].join('')
        //   // generate a form data
        //   var formData = new FormData()
        //   formData.append('filename', filename)
        //   formData.append('file', blob)
        //   // upload image to your server
        //   callUploadAPI(your_upload_url, formData, (err, res) => {
        //     if (err) return
        //     // success? you should return the uploaded image's url
        //     // then insert into the quill editor
        //     const index = (quill.getSelection() || {}).index || quill.getLength()
        //     if (index) quill.insertEmbed(index, 'image', res.data.image_url, 'user')
        //   })
    };
    return HtmlEditorComponent;
}());
export { HtmlEditorComponent };
